import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import { Animation } from '../Animation';
import styles from './LayeredAnimation.module.less';

const LayeredAnimation = ({
  dataLayers,
  onAnimationCompleted,
  onAnimationLoopCompleted,
  name,
  loop,
  autoplay,
  isStopped,
  isPaused,
  height,
  width,
}) => {
  const [completed, setCompleted] = useState({});
  const [loopCompleted, setLoopCompleted] = useState({});

  const onAnimationCompletedHandler = ({ name: nameLayer }) => {
    setCompleted({
      ...completed,
      [nameLayer]: true,
    });
  };

  const onAnimationLoopCompletedHandler = ({ name: nameLayer }) => {
    setLoopCompleted({
      ...loopCompleted,
      [nameLayer]: true,
    });
  };

  useEffect(() => {
    if (Object.entries(completed).length === dataLayers.length) {
      onAnimationCompleted({ name });
    }

    if (Object.entries(loopCompleted) === dataLayers.length) {
      setLoopCompleted({});
      onAnimationLoopCompleted({ name });
    }
  }, [completed, loopCompleted, name]);

  const layersSorted = useMemo(() => sortBy(dataLayers, ['position']), [dataLayers]);

  return (
    <div className={styles.container} style={{ height }}>
      {layersSorted.map(({ data }, index) => (
        <div key={`${name}-${index}`} style={{ height, maxWidth: width }} className={styles.layerContainer}>
          <Animation
            name={`${name}-${index}`}
            loop={loop}
            data={data}
            autoplay={autoplay}
            isStopped={isStopped}
            isPaused={isPaused}
            onAnimationCompleted={onAnimationCompletedHandler}
            onAnimationLoopCompleted={onAnimationLoopCompletedHandler}
          />
        </div>
      ))}
    </div>
  );
};

LayeredAnimation.propTypes = {
  name: PropTypes.string.isRequired,
  loop: PropTypes.bool,
  height: PropTypes.string,
  autoplay: PropTypes.bool,
  dataLayers: PropTypes.array.isRequired,
  onAnimationCompleted: PropTypes.func,
  onAnimationLoopCompleted: PropTypes.func,
  isStopped: PropTypes.bool,
  isPaused: PropTypes.bool,
  width: PropTypes.string,
};

LayeredAnimation.defaultProps = {
  loop: false,
  autoplay: true,
  height: undefined,
  onAnimationCompleted: undefined,
  onAnimationLoopCompleted: undefined,
  isStopped: undefined,
  isPaused: undefined,
  width: undefined,
};

export default LayeredAnimation;

// const LayeredAnimation = () => <div></div>;

// export default LayeredAnimation;
